import { useQuery } from "@tanstack/react-query"
import * as performanceServices from "../service/Performance"
import { GroupingOptions } from "../api/generated"
import { formatDateForBackend } from "../util/formatDate"

const TEAM_PERFORMANCE = "team_performance"
const INDIVIDUAL_PERFORMANCE = "individual_performance"

export const useGetTeamsPerformance = (
  teamId: number,
  startDate: string,
  endDate: string,
) => {
  return useQuery({
    queryKey: [TEAM_PERFORMANCE, teamId, startDate, endDate],
    queryFn: () =>
      performanceServices.getTeamPerformance(teamId, startDate, endDate),
    placeholderData: [],
    enabled: teamId !== -1,
  })
}

export const useGetIndividualPerformance = (grouping: GroupingOptions) => {
  const todayFormatted = formatDateForBackend()

  return useQuery({
    queryKey: [INDIVIDUAL_PERFORMANCE, grouping],
    queryFn: () =>
      performanceServices.getIndividualPerformance(
        todayFormatted,
        todayFormatted,
        grouping
      ),
    placeholderData: [],
    staleTime: 5 * 60 * 1000,
  })
}
